import getUrl from './getUrl';
import { HOST_TYPE } from './host';

const getRequestUrl = (endpoint: string, rest: any = {}) =>
  getUrl({
    endpoint,
    hostType: HOST_TYPE.UNACADEMY_ICONS,
    nextPreviewMode: false,
    ...rest
  });

const getFetcherOptions = (rest: any = {}) => ({
  useCamleCase: true,
  hostType: HOST_TYPE.UNACADEMY_ICONS,
  useOriginalURL: true,
  hasAppClient: true,
  ...rest
});

export { getFetcherOptions, getRequestUrl };
